<template>
  <div class="callme_total_wrap hidden-xs-only">
    <div class="callme_bottom_wrap" v-if="navList.length">
      <div class="bottom_container pc_container" >
        <div class="items_wrap" v-for="(item, index) in navList" :key="index">
          <div class="item_tit" @click="goLink(item)">{{item.name}}</div>
          <div class="item_options" v-if="item.children && item.children.length > 0">
            <div v-for="(i, j) in item.children" :key="j"><span @click="handleToRouter(i.href)">{{i.name}}</span></div>
          </div>
        </div>
        <div class="items_wrap">
          <div class="item_options">
            <img :src="company.footer_qr.image != '' ? company.footer_qr.image : require('@/assets/images/footer/code.jpg')" alt="" />
            <span style="text-align: left; margin-top: 15px">{{company.footer_qr.tips}}</span>
          </div>
        </div>
      </div>
      <div class="navigate_wrap pc_container">
        <span>{{company.name}}</span>
        <span style="margin-left: 20px">版权公司所有</span>
        <span style="margin-left: 20px">{{company.coryright}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  computed: {
    company() {
      return this.$store.state.company
    },
    navList() {
      return this.$store.state.menu
    },
  },
  methods: {
    goLink(item){
      console.log(item)
      if(item.children && item.children.length > 0){
        return
      }else{
        this.$router.push(item.herf).catch((v) => {})
      }
    },
    handleToRouter(url){
      this.$router.push(url).catch((v) => {})
    },
  },
}
</script>

<style lang="scss" scoped>
.callme_total_wrap {
  width: 100%;
  .callme_bottom_wrap {
    width: 100%;
    background: #2a59ab;
    color: #fff;
    padding-top: 30px;
    .bottom_container {
      display: flex;
      padding-bottom: 30px;
      border-bottom: solid #FFF 2px;
      justify-content: space-around;
      .items_wrap {
        .item_tit {
          font-weight: bold;
          font-size: 20px;
          color: #FFF;
          cursor: pointer;
        }
        .item_options {
          display: flex;
          flex-direction: column;
          width: 120px;
          div {
            font-size: 17px;
            color: #FFF;
            margin-top: 10px;
            cursor: pointer;
            &:hover {
              font-weight: bold;
            }
          }
          img {
            width: 100%;
          }
        }
      }
    }
    .navigate_wrap {
      margin-top: 30px;
      padding-bottom: 15px;
      // word-break: keep-all;
      // word-wrap: break-word;
      display: flex;
      flex-wrap: wrap;
      color: #ffffff;
      justify-content: center;
      font-size: 16px;
      span {
        font-size: 16px;
      }
    }
  }
}
</style>
